import PopoverTemplate from '../../html/components/popover.html'
import PopoverHeaderTemplate from '../../html/components/popover-header.html'
import PopoverContentTemplate from '../../html/components/popover-content.html'
import PopoverMenuTemplate from '../../html/components/popover-menu.html'
import PopoverActionTemplate from '../../html/components/popover-action.html'
import PopoverToggleTemplate from '../../html/components/popover-toggle.html'

import {inert} from '../shared/directives'
import Component from '../shared/component'
import Relation, {HasOne, MemberOf} from '../shared/mixins/relation'
import {PopperMixin, PopperToggleMixin} from '../shared/mixins/popper'

import {InteractiveMixin} from './interactive'

const popoverToggle = Relation()
const popoverHeader = Relation()

export const Popover = Component('v-popover', {
  mixins: [
    HasOne(popoverHeader, 'header'),
    MemberOf(popoverToggle, 'toggle'),
    PopperMixin('toggle')
  ],
  directives: {
    inert
  },
  template: PopoverTemplate,
  props: {
    fill: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    open () {
      const {toggle} = this

      if (toggle) {
        return toggle.open
      }

      return true
    },

    style () {
      const {fill, popper} = this
      return {
        ...popper.style,
        width: fill && popper.boundaries
          ? `${popper.boundaries.width}px`
          : null
      }
    }
  }
})

export const PopoverHeader = Component('v-popover-header', {
  mixins: [
    MemberOf(popoverHeader, 'popover')
  ],
  template: PopoverHeaderTemplate
})

export const PopoverContent = Component('v-popover-content', {
  template: PopoverContentTemplate
})

export const PopoverMenu = Component('v-popover-menu', {
  template: PopoverMenuTemplate
})

export const PopoverAction = Component('v-popover-action', {
  mixins: [
    InteractiveMixin
  ],
  template: PopoverActionTemplate
})

export const PopoverToggle = Component('v-popover-toggle', {
  mixins: [
    HasOne(popoverToggle, 'popover'),
    PopperToggleMixin('popover')
  ],
  template: PopoverToggleTemplate,
  data () {
    return {
      open: false
    }
  },
  computed: {
    target () {
      const {popover} = this

      if (popover) {
        return popover.id
      }
    }
  },
  watch: {
    open () {
      if (!this.popover) {
        return
      }

      if (this.open) {
        this.pop()
      } else {
        this.unpop()
      }
    }
  },
  methods: {
    toggle () {
      if (this.open) {
        this.hide()
      } else {
        this.show()
      }
    },

    show () {
      if (!this.open) {
        this.open = true
      }
    },

    hide () {
      if (this.open) {
        this.open = false
      }
    }
  }
})

export const PopoverToggleMixin = {
  props: {
    popover: {
      type: Object,
      default: null
    }
  }
}
